import Guard from 'arg-guard'

import Config from '../app.config'

/**
 * Defined structure of a renovation submission.
 * @export RenovationDataSubmission
 * @class RenovationDataSubmission
 */
export default class RenovationDataSubmission {

    /**
     * Creates an instance of a RenovationDataSubmission.
     * @param {Project} project The project model - Must already have name set.
     * @param {Scheme} presentationScheme as an object
     * @param {Scheme|?number} servicedScheme as an object or identifier
     * @memberof RenovationDataSubmission
     */
    constructor(project, presentationScheme, servicedScheme = null) {
        Guard.throwIf(project, 'project')
        Guard.throwIf(presentationScheme, 'presentationScheme')
        Guard.throwIf(project.name, 'project.name')

        /**
         * @type {string}
         */
        this.name = project.name

        /**
         * @type {number}
         */
        this.schemeId = presentationScheme.id

        /**
         * @type {number}
         */
        this.servicedSchemeId = servicedScheme && servicedScheme.id
            ? servicedScheme.id : servicedScheme ? servicedScheme : null

        /**
         * @type {number}
         */
        this.budget = project.budget === Number.MAX_VALUE || project.budget > Config.serverMaxBudget
            ? Config.serverMaxBudget
            : project.budget

        /**
         * @type {number}
         */
        this.cost = presentationScheme.priceless ? 0 : project.cost

        /**
         * @type {string}
         */
        this.motivation = project.motivation

        /**
         * @type {string}
         */
        this.status = project.status

        /**
         * @type {Array<{id, name}>}
         */
        this.selectedImprovements = project.addedImprovements
            .map(imp => {
                return { id: imp.id, name: imp.title }
            })

        if (project.notes) {
            /**
             * @type {Array<{key, value}>}
             */
            this.notes = project.notes
        }

        if (project.services) {
            /**
             * @type {Array<{key, value}>}
             */
            this.services = project.services
        }
    }
}
